export default __webpack_public_path__ + "static/media/menu-dots.cc59f83e.svg";